/**
 * Warmup logic for NavigationWarmupShell
 */
export async function warmup(): Promise<void> {
  try {
    // Add specific warmup logic here if needed
  } catch {
    // Ignore errors to not block warmup
  }
}